import { createTanstackQueryUtils } from "@orpc/tanstack-query";
import { orpcFetch } from "./orpc.client";

export const orpc = createTanstackQueryUtils(orpcFetch);
